var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.ref,staticClass:"fx_chart_pie_container"},[(_vm.title)?_c('div',{staticClass:"fx_chart_title",style:(_vm.titleStyle)},[_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("default")],2):_vm._e(),_c('div',{style:({'height':`${_vm.chartHeight}`})},[_c('div',{ref:_vm.chartRef,staticClass:"fx_chart_pie"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }